import { render, staticRenderFns } from "./CamposDisponiveis.vue?vue&type=template&id=0d0b16e0&scoped=true"
import script from "./CamposDisponiveis.vue?vue&type=script&lang=js"
export * from "./CamposDisponiveis.vue?vue&type=script&lang=js"
import style0 from "./CamposDisponiveis.vue?vue&type=style&index=0&id=0d0b16e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0b16e0",
  null
  
)

export default component.exports